import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonHttpDataService {

  constructor() { }

  handleServiceErrors(error: HttpErrorResponse){
    if(error.status == 0){
      return throwError("Network Error Occured")
    } else {
      return throwError({
        message: "Server error occured.",
        status: error.status,
        error: error.error
      })
    }
  }
}
